import React, { Dispatch, FC, SetStateAction } from 'react';
import { I18n } from '@fiverr-private/i18n-react';
import { PlusIcon } from '@fiverr-private/icons';
import { Button } from '@fiverr-private/button';
import { CurrentViewState, WorkExperienceViewStates } from '../../../shared/types';
import { EMPTY_T_PREFIX } from '../../AddWorkExperienceBlock';

interface AddExperienceButtonProps {
    setCurrentViewState: Dispatch<SetStateAction<CurrentViewState>>;
}

const AddExperienceButton: FC<AddExperienceButtonProps> = ({ setCurrentViewState }) => (
    <Button
        variant="outline"
        intent="secondary"
        onClick={() =>
            setCurrentViewState((state) => ({
                ...state,
                viewState: WorkExperienceViewStates.AddEdit,
                experienceId: undefined,
            }))
        }
    >
        <PlusIcon size={12} />
        <I18n k={`${EMPTY_T_PREFIX}.add_button`} />
    </Button>
);

export default AddExperienceButton;
